import React from 'react'
import { useEffect } from 'react'
import { useAppContextState } from "app/@hooks"
import { createContext, useContextSelector } from "use-context-selector"
import { isEmpty, postSubmit } from "ui-seeker/utils"
import { COMPETITION_URL } from "app/@common/constants"
import { CompetitionAnalyzerSubmittedFiltersContext } from "../index"
import { useAppHashCompare } from 'app/@hooks'

const Context = createContext({})

const initialState = { locationData: {}, isLoading: false }

export function CompetitionAnalyzerLocationDataProvider({ children }) {
    const { state, updateState } = useAppContextState(initialState)
    const submittedFilters = useContextSelector(CompetitionAnalyzerSubmittedFiltersContext, ({ state }) => state)
    // the destination summary does not depend on the hotels excluded from the compset: an exclusion toggle
    // must not refetch it (nor flash the cards loader)
    // eslint-disable-next-line no-unused-vars
    const { excludedHotelID, ...locationFilters } = submittedFilters || {}
    const filtersChanged = useAppHashCompare(locationFilters)

    useEffect(() => {
        if (!isEmpty(submittedFilters) && submittedFilters.cachedQuery) {
            updateState({ isLoading: true })
            postSubmit(`${COMPETITION_URL.LOCATION_DATA}`, submittedFilters)
                .then(locationData => {
                    updateState({
                        locationData,
                        isLoading: false
                    })
                })
                .catch(() => updateState({ isLoading: false }))
        }
    }, [filtersChanged])

    return <Context.Provider value={{ state, updateState }}>
        {children}
    </Context.Provider>
}

export default Context 